import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { TenantConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { TenantService } from './api/tenant.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class TenantApiModule {
    public static forRoot(configurationFactory: () => TenantConfiguration): ModuleWithProviders<TenantApiModule> {
        return {
            ngModule: TenantApiModule,
            providers: [ { provide: TenantConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: TenantApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('TenantApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
